module.exports = __webpack_public_path__ + "static/media/balloon-small.82b44f3d.svg";